import * as React from 'react';
import OwnerEditor from './OwnerEditor';

import { IOwner } from '../../types';
import { url, safeJsonParse, createFetchOptions } from '../../util';

interface IEditOwnerPageProps {
  params?: { ownerId?: string };
}

interface IEditOwnerPageState {
  owner?: IOwner;
  loading?: boolean;
  error?: string;
}

export default class EditOwnerPage extends React.Component<IEditOwnerPageProps, IEditOwnerPageState> {
  state: IEditOwnerPageState = {
    loading: true
  };
  private _isMounted: boolean = false;
  
  componentDidMount() {
    this._isMounted = true;
    this.loadOwner();
  }

  componentWillReceiveProps(nextProps: IEditOwnerPageProps) {
    // Reload owner when route params change
    const currentOwnerId = this.props.params && this.props.params.ownerId;
    const nextOwnerId = nextProps.params && nextProps.params.ownerId;
    if (nextOwnerId && nextOwnerId !== currentOwnerId) {
      this.loadOwner();
    }
  }

  loadOwner() {
    const { params } = this.props;

    if (params && params.ownerId) {
      this.setState({ loading: true, error: undefined });
      const fetchUrl = url(`/api/owners/${params.ownerId}`);
      console.log('EditOwnerPage: Fetching owner from:', fetchUrl);
      fetch(fetchUrl, createFetchOptions())
        .then(response => {
          console.log('EditOwnerPage: Response status:', response.status);
          if (response.status === 404) {
            throw new Error('Owner not found');
          }
          if (response.status >= 400) {
            throw new Error(`Failed to load owner: HTTP ${response.status}`);
          }
          return safeJsonParse(response);
        })
        .then(owner => {
          console.log('EditOwnerPage: Owner data received:', owner);
          // Ensure isNew is false for edit mode
          if (owner) {
            owner.isNew = false;
          }
          if (this._isMounted) {
            this.setState({ owner, loading: false, error: undefined });
          }
        })
        .catch(error => {
          console.error('EditOwnerPage: Error loading owner:', error);
          if (this._isMounted) {
            this.setState({ 
              owner: undefined, 
              loading: false, 
              error: error.message || 'Failed to load owner details' 
            });
          }
        });
    } else {
      this.setState({ loading: false, error: 'No owner ID provided' });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { owner, loading, error } = this.state;

    if (loading) {
      return <div><h2>Loading owner details...</h2></div>;
    }

    if (error) {
      return (
        <div>
          <h2>Error</h2>
          <p className="text-danger">{error}</p>
        </div>
      );
    }

    if (!owner) {
      return <div><h2>No Owner loaded</h2></div>;
    }

    return <OwnerEditor initialOwner={owner} />;
  }
}
